import { useState, useEffect } from 'react'
import { Plan } from '../types'
import { apiService, ApiError } from '../services/api'

interface UsePlansReturn {
 plans: Plan[]
 isLoading: boolean
 error: string | null
 refetch: () => Promise<void>
}

export const usePlans = (): UsePlansReturn => {
 const [plans, setPlans] = useState<Plan[]>([])
 const [isLoading, setIsLoading] = useState(true)
 const [error, setError] = useState<string | null>(null)

 const fetchPlans = async () => {
 try {
 setIsLoading(true)
 setError(null)
 
 const response = await apiService.getPlans()
 
 // A API retorna diretamente um array de planos
 const plansData = Array.isArray(response) ? response : (response.data || [])
 
 setPlans(plansData)
 } catch (err) {
 const errorMessage = err instanceof ApiError 
 ? err.message 
 : 'Erro ao carregar planos'
 
 setError(errorMessage)
 console.error('Erro ao buscar planos:', err)
 setPlans([]) // Lista vazia em caso de erro
 } finally {
 setIsLoading(false)
 }
 }

 useEffect(() => {
 fetchPlans()
 }, [])

 const refetch = async () => {
 await fetchPlans()
 }

 return {
 plans,
 isLoading,
 error,
 refetch
 }
}

